<template>
    <div class="business_wrapper">
        <v-row class="search_box">
            <v-col>
              <topNav></topNav>
            </v-col>
        </v-row>
        <div class="common_tabs_wrapper">
            <div class="md_title mart24 marb12">企业画像</div>
            <v-row>
                <v-col sm="10" md="10">
                    <v-row class="flex_style left simple_search">
                        <v-col xs="4" sm="10" class="input_box">
                            <v-combobox
                                v-model="model"
                                :items="items"
                                label="搜索企业..."
                                :search-input.sync="search"
                                solo
                                clearable
                                light
                                hide-details
                                hide-selected
                                >
                            </v-combobox>
                        </v-col>
                        <v-col xs="4" sm="2" class="right_btn hand" @click="goResult">
                            <span class="text">开始画像</span>
                        </v-col> 
                    </v-row>
                </v-col>
            </v-row>
            <div class="business_content">
                <v-tabs>
                    <v-tab key="1">统计图表</v-tab>
                    <v-tab key="2">统计数据</v-tab>
                    <v-tab-item key="1">
                        <v-overlay :value="isLoading">
                        <v-progress-circular
                            indeterminate
                            size="64"
                        ></v-progress-circular>
                        </v-overlay>
                        <div class="common_tabs_wrapper">
                            <div class="flex_style left first_row">
                                <div class="w50 right">
                                    <div id="chart1" style="height: 350px"></div>
                                </div>
                                <div class="w50 left">
                                    <div id="chart2" style="height: 350px"></div>
                                </div>
                            </div>
                            <div class="flex_style left">
                                <div class="w100">
                                    <div id="chart3" style="height: 350px"></div>
                                </div>
                            </div>
                            <div class="flex_style left">
                                <div class="w100">
                                    <div id="chart8" style="height: 350px"></div>
                                </div>
                            </div>
                            <div class="flex_style left">
                                <div class="w100">
                                    <div id="chart9" style="height: 350px"></div>
                                </div>
                            </div>
                            <div class="flex_style left">
                                <div class="w100">
                                    <div id="chart10" style="height: 350px"></div>
                                </div>
                            </div>
                            <div class="flex_style left">
                                <div class="w100">
                                    <div id="chart11" style="height: 350px"></div>
                                </div>
                            </div>
                            <div class="flex_style left">
                                <div class="w100">
                                    <div id="chart4" style="height: 350px"></div>
                                </div>
                            </div>
                            <div class="flex_style left">
                                <div class="w100">
                                    <div id="chart5" style="height: 350px"></div>
                                </div>
                            </div>
                            <div class="flex_style left">
                                <div class="w100">
                                    <div id="chart6" style="height: 350px"></div>
                                </div>
                            </div>
                            <div class="flex_style left">
                                <div class="w100">
                                    <div id="chart7" style="height: 350px"></div>
                                </div>
                            </div>
                        </div>
                    </v-tab-item>
                    <v-tab-item key="2">
                        <v-overlay :value="isLoading">
                        <v-progress-circular
                            indeterminate
                            size="64"
                        ></v-progress-circular>
                        </v-overlay>
                        <div class="common_tabs_wrapper" v-if="enterPriseInfo">
                            <div class="flex_style1" v-if="enterPriseInfo.map1 || enterPriseInfo.map2 || enterPriseInfo.map4">
                                <div class="enter_table w28">
                                    <div class="title_name">专利类型</div>
                                    <div class="flex_style left tr">
                                        <div class="td">专利类型</div>
                                        <div class="td">数量</div>
                                    </div>
                                    <div class="flex_style left tr" v-for="(item,key,index) in enterPriseInfo.map1" :key="index">
                                        <div class="td">{{key}}</div>
                                        <div class="td">{{item}}</div>
                                    </div>
                                </div>
                                <div class="enter_table w28">
                                    <div class="title_name">专利状态</div>
                                    <div class="flex_style left tr">
                                        <div class="td">专利状态</div>
                                        <div class="td">数量</div>
                                    </div>
                                    <div class="flex_style left tr" v-for="(item,key,index) in enterPriseInfo.map2" :key="index">
                                        <div class="td">{{key}}</div>
                                        <div class="td">{{item}}</div>
                                    </div>
                                </div>
                                <div class="enter_table w28">
                                    <div class="title_name">专利区域分布</div>
                                    <div class="flex_style left tr">
                                        <div class="td">区域</div>
                                        <div class="td">数量</div>
                                    </div>
                                    <div class="flex_style left tr" v-for="(item,key,index) in enterPriseInfo.map4" :key="index">
                                        <div class="td">{{key}}</div>
                                        <div class="td">{{item}}</div>
                                    </div>
                                </div>
                            </div>
                            <div class="enter_table" v-if="enterPriseInfo.map3">
                                <div class="title_name">专利法律状况变化趋势</div>
                                <div class="flex_style left tr">
                                    <div class="td">时间</div>
                                    <div class="td">有效专利</div>
                                    <div class="td">无效专利</div>
                                    <div class="td">失效专利</div>
                                    <div class="td">公开</div>
                                    <div class="td">实质审查</div>
                                </div>
                                <div class="flex_style left tr" v-for="(item,key,index) in enterPriseInfo.map3" :key="index">
                                    <div class="td">{{key}}</div>
                                    <div class="td">{{item['有效专利']}}</div>
                                    <div class="td">{{item['无效专利']}}</div>
                                    <div class="td">{{item['失效专利']}}</div>
                                    <div class="td">{{item['公开']}}</div>
                                    <div class="td">{{item['实质审查']}}</div>
                                </div>
                            </div>
                            <div class="enter_table" v-if="enterPriseInfo.map5">
                                <div class="title_name">专利区域申请趋势</div>
                                <div class="flex_style left tr">
                                    <div class="td">时间</div>
                                    <div class="td">中国</div>
                                    <div class="td">WIPO</div>
                                </div>
                                <div class="flex_style left tr" v-for="(item,key,index) in enterPriseInfo.map5" :key="index">
                                    <div class="td">{{key}}</div>
                                    <div class="td">{{item['中国']}}</div>
                                    <div class="td">{{item['WIPO']}}</div>
                                </div>
                            </div>
                        
                            <div class="enter_table" v-if="enterPriseInfo.map7">
                                <div class="title_name">主要技术领域的主要竞争对手</div>
                                <div class="flex_style left tr" v-for="(item,key,index) in enterPriseInfo.map7" :key="index">
                                    <div class="td">{{key}}</div>
                                    <div class="td">
                                        <span v-for="(item1,key1,index1) in item" :key="index1">
                                            {{key1}}: {{item1}}
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div class="flex_style1" v-if="enterPriseInfo.map8 || enterPriseInfo.map9|| enterPriseInfo.map10">
                                <div class="enter_table w28">
                                    <div class="title_name">专利申请趋势</div>
                                    <div class="flex_style left tr">
                                        <div class="td">日期</div>
                                        <div class="td">专利量</div>
                                    </div>
                                    <div class="flex_style left tr" v-for="(item,key,index) in enterPriseInfo.map8" :key="index">
                                        <div class="td">{{key}}</div>
                                        <div class="td">{{item}}</div>
                                    </div>
                                </div>
                                <div class="enter_table w28">
                                    <div class="title_name">专利公开趋势</div>
                                    <div class="flex_style left tr">
                                        <div class="td">日期</div>
                                        <div class="td">专利量</div>
                                    </div>
                                    <div class="flex_style left tr" v-for="(item,key,index) in enterPriseInfo.map9" :key="index">
                                        <div class="td">{{key}}</div>
                                        <div class="td">{{item}}</div>
                                    </div>
                                </div>
                                <div class="enter_table w28">
                                    <div class="title_name">专利授权趋势</div>
                                    <div class="flex_style left tr">
                                        <div class="td">日期</div>
                                        <div class="td">专利量</div>
                                    </div>
                                    <div class="flex_style left tr" v-for="(item,key,index) in enterPriseInfo.map10" :key="index">
                                        <div class="td">{{key}}</div>
                                        <div class="td">{{item}}</div>
                                    </div>
                                </div>
                            </div>
                            <div class="flex_style1" v-if="enterPriseInfo.map6 || enterPriseInfo.map11">
                                <div class="enter_table w44">
                                    <div class="title_name">专利技术领域分布</div>
                                    <div class="flex_style left tr">
                                        <div class="td">IPC分类</div>
                                        <div class="td">专利量</div>
                                    </div>
                                    <div class="flex_style left tr" v-for="(item,index) in enterPriseInfo.map6" :key="index">
                                        <div class="td">{{item.key}}</div>
                                        <div class="td">{{item.value}}</div>
                                    </div>
                                </div>
                                <div class="enter_table w44">
                                    <div class="title_name">主要发明人</div>
                                    <div class="flex_style left tr">
                                        <div class="td">发明人</div>
                                        <div class="td">专利量</div>
                                    </div>
                                    <div class="flex_style left tr" v-for="(item,index) in enterPriseInfo.map11" :key="index">
                                        <div class="td">{{item.key}}</div>
                                        <div class="td">{{item.value}}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </v-tab-item>
                </v-tabs>
            </div>
        </div>
    </div>
</template>
<script>
import topNav from "@/components/widgets/topNav.vue";
import echarts from "echarts";
import world from "echarts/map/json/world.json";
import wordNameList from '../../assets/world_code_name.json';
import {mapActions} from 'vuex';
import Qs from 'qs'
export default {
    data() {
        return {
            attrs: {
                class: 'mb-6',
                boilerplate: true,
                elevation: 12,
            },
            model: '',
            items: [],
            isLoading: false,
            search: '',
            enterPriseInfo: {},
            myChart1: '',
            myChart2: '',
            myChart3: '',
            myChart4: '',
            myChart5: '',
            myChart6: '',
            myChart7: '',
            myChart8: '',
            myChart9: '',
            myChart10: '',
            myChart11: '',
            worldInfo: ''
        }
    },
    watch: {
        search(val) {
            this.getSuggest(val)
        },
    },
    components: {
        topNav
    },
    mounted() {
        echarts.registerMap("world", world);
    },
    methods: {
        ...mapActions('search',['querySug']),
        ...mapActions('analy',['enterPriseAnalyse']),
        getSuggest(val) {
            let _this = this
            let data = {
            params: {
                q: val
            }
            }
            this.querySug({data: data,handle(res) {
            let data = res.data
            let newData = []
            if(data&&data.length>0) {
                data.forEach((item)=>{
                    newData.push(item.text)
                })
            }
            _this.items = newData
            }})
        },
        goResult() {
            if(!this.model) {
                this.$message({
                    type: 'info',
                    message: '请输入关键字'
                })
                return false
            }
            this.isLoading = true
            let data = {
                params: {
                    enterpriseName: this.model
                }
            }
            let _this = this
            this.initChart()
            this.enterPriseAnalyse({data: data,handle(res) {
                _this.isLoading = false
                // _this.initChart()
                let map1 = []
                for(let i in res.map1) {
                    map1.push({
                        'value': res.map1[i],
                        'name': i
                    })
                }
                let map2 = []
                for(let i in res.map2) {
                    map2.push({
                        'value': res.map2[i],
                        'name': i
                    })
                }
                let map3_tilte = '专利法律状况变化趋势'
                let map4_tilte = '专利区域分布'
                let map5_title = '专利区域申请趋势'
                let map6_title = '专利技术领域分布'
                let map7_title = '主要技术领域的主要竞争对手'
                let map8_title = '专利申请趋势'
                let map9_title = '专利公开趋势'
                let map10_title = '专利授权趋势'
                let map11_title = '主要发明人'
                _this.getWorldMap(res.map4,_this.myChart4,map4_tilte)
                _this.pieChart('专利类型', map1,_this.myChart1)
                _this.pieChart('专利状态', map2,_this.myChart2)
                _this.getMap(res.map3,_this.myChart3,map3_tilte)
                _this.getMap(res.map5,_this.myChart5,map5_title)
                _this.getMap2(res.map6,_this.myChart6,map6_title)
                _this.getMap1(res.map8,_this.myChart8,map8_title)
                _this.getMap1(res.map9,_this.myChart9,map9_title)
                _this.getMap1(res.map10,_this.myChart10,map10_title)
                _this.getMap2(res.map11,_this.myChart11,map11_title)
                _this.getScatter(res.map7,_this.myChart7,map7_title)
                _this.enterPriseInfo = res
            }})
        },
        clearChart() {
            this.myChart1.clear()
            this.myChart2.clear()
            this.myChart3.clear()
            this.myChart4.clear()
            this.myChart5.clear()
            this.myChart6.clear()
            this.myChart7.clear()
            this.myChart8.clear()
            this.myChart9.clear()
            this.myChart10.clear()
            this.myChart11.clear()
            this.myChart12.clear()
        },
        initChart() {
            this.myChart1 = echarts.init(document.getElementById("chart1"));
            this.myChart2 = echarts.init(document.getElementById("chart2"));
            this.myChart3 = echarts.init(document.getElementById("chart3"));
            this.myChart4 = echarts.init(document.getElementById("chart4"));
            this.myChart5 = echarts.init(document.getElementById("chart5"));
            this.myChart6 = echarts.init(document.getElementById("chart6"));
            this.myChart7 = echarts.init(document.getElementById("chart7"));
            this.myChart8 = echarts.init(document.getElementById("chart8"));
            this.myChart9 = echarts.init(document.getElementById("chart9"));
            this.myChart10 = echarts.init(document.getElementById("chart10"));
            this.myChart11 = echarts.init(document.getElementById("chart11"));
            window.addEventListener("resize", () => {
                this.myChart1.resize();
                this.myChart2.resize();
                this.myChart3.resize();
                this.myChart4.resize();
                this.myChart5.resize();
                this.myChart6.resize();
                this.myChart7.resize();
                this.myChart8.resize();
                this.myChart9.resize();
                this.myChart10.resize();
                this.myChart11.resize();
            });
        },
        pieChart(title, data,chart) {
            chart.clear()
            let  option = {
                title: {
                    text: title,
                    left: 'left',
                    top: 4,
                    textStyle: {
                        color: '#333'
                    }
                },
                legend: {
                    top: 30,
                    type: 'scroll',
                },
                tooltip: {
                    trigger: 'item'
                },
                toolbox: {
                    show: true,
                    feature: {
                        mark: {show: true},
                        dataView: {show: true, readOnly: false},
                        restore: {show: false},
                        saveAsImage: {show: false}
                    }
                },
                series: [
                    {
                        name: title,
                        type: 'pie',
                        radius: ['8%', '70%'],
                        center: ['50%', '60%'],
                        roseType: 'area',
                        itemStyle: {
                            borderRadius: 8
                        },
                        data: data
                    }
                ]
            };
            chart.setOption(option)
        },
        lineChart(title,data,chart) {
            let option = {
                title: {
                    text: title
                },
                tooltip: {
                    trigger: 'axis'
                },
                legend: {
                    data: data.legend
                },
                grid: {
                    left: '3%',
                    right: '4%',
                    bottom: '3%',
                    containLabel: true
                },
                toolbox: {
                    feature: {
                        saveAsImage: {}
                    }
                },
                xAxis: {
                    type: 'category',
                    boundaryGap: false,
                    data: data.xAxis
                },
                yAxis: {
                    type: 'value'
                },
                series: data.list
            };
            chart.setOption(option)
        },
        barChart(title,data,chart) {
            let option = {
                title: {
                    text: title
                },
                tooltip: {
                    trigger: 'item'
                },
                xAxis: {
                    type: 'category',
                    data: data.xAxis
                },
                yAxis: {
                    type: 'value'
                },
                series: data.list
            };
            chart.setOption(option)
        },
        worldMapChart(title,data,chart) {
            let option = {
                title: {
                    text: title
                },
                tooltip: {
                    formatter: function (params, ticket, callback) {
                        params.value = params.value ? params.value: 0
                        return params.name + "：" + params.value + " 条";
                    },
                },
                visualMap: {
                    min: 0,
                    max: 60000,
                    left: "6%",
                    top: "bottom",
                    text: ["高", "低"],
                    inRange: {
                    color: ["#ff0011", "#476a9d"],
                    },
                    show: false,
                },
                //   nameMap: this.nameMap,
                geo: {
                    map: "world",
                    roam: false,
                    zoom: 1.23,
                    selectedMode: 'multiple',
                    label: {
                    normal: {
                        show: false,
                        fontSize: "10",
                        color: "rgba(0,0,0,0.7)",
                    },
                    },
                    itemStyle: {
                    normal: {
                        borderColor: "rgba(255, 255, 255, 0.4)",
                    },
                    emphasis: {
                        areaColor: "#ff7c3c",
                        shadowOffsetX: 0,
                        shadowOffsetY: 0,
                        shadowBlur: 20,
                        borderWidth: 0,
                        shadowColor: "rgba(0, 0, 0, 0.3)",
                    },
                    },
                },
                series: {
                    name: title,
                    type: "map",
                    geoIndex: 0,
                    itemStyle: {
                        areaColor: 'green'
                    },
                    emphasis: {
                        label: {
                            show: true
                        },
                        itemStyle: {
                            areaColor: 'yellow',
                            color: 'blue'
                        }
                    },
                    data: data
                },
            };
            chart.setOption(option)
        },
        scatterChart(title,data,chart) {
            let option = {
                title: {
                    text: title
                },
                tooltip: {
                    trigger: 'item',
                    formatter: function(params) {
                        let temp = params.data
                        let x = data.xData[temp[0]]
                        let y = data.yData[temp[1]]
                        let num = data.list[params.seriesIndex].num
                        return x + '-' + y + '</br>' + '专利量：' + num
                    },
                },
                backgroundColor: 'rgb(255,255,255)',
                padding: 10,
                xAxis: {
                    name: '',
                    boundaryGap: ['10%', '0%'],
                    nameTextStyle: {
                        fontSize: 15,
                        color: '#666',
                        verticalAlign: 'bottom',
                        fontWeight: 'bold'
                    },
                    scale: true,
                    axisTick: {
                        show: false
                    },
                    axisLabel: {
                        formatter: function(params){
                            return data.xData[params];
                        }
                    },
                    interval: 1,
                    splitNumber: data.xData.length,
                    splitLine: {
                        show: true,
                        lineStyle: {
                            type: 'dashed',
                            color: '#e3e3e3'
                        }
                    }
                },
                // color: ['rgb(228, 164, 52)'],
                yAxis: {
                    name: '',
                    boundaryGap: ['5%', '0%'],
                    nameTextStyle: {
                        align: 'right',
                        fontSize: 15,
                        color: '#666',
                        fontWeight: 'bold'
                    },
                    interval: 1,
                    splitNumber: data.yData.length,
                    scale: true,
                    axisLine: {
                        show: false
                    },
                    axisTick: {
                        show: false
                    },
                    axisLabel: {
                        show: true,
                        formatter: function(idx){
                            return data.yData[idx];
                        }
                    },
                    splitLine: {
                        show: true,
                        lineStyle: {
                            type: 'dashed',
                            color: '#e3e3e3'
                        }
                    }
                },
                series: data.list.map((d, i)=>{
                    return {
                        type: 'scatter',
                        label: {
                            show: false,
                            // formatter: function(params){
                            //     return data.list[params.seriesIndex].num;
                            // }
                        },
                        emphasis: {
                            show: true,
                        },
                        // symbolSize: d.num*2,
                        data: [ 
                            [
                                data.xData.indexOf(d.xName), 
                                data.yData.indexOf(d.yName)
                            ]
                        ]
                    }
                })
            }
            chart.setOption(option)
        },
        getMap(result,chart,title) {
            let map3 = []
                let map3_data = {}
                let map3_xAxis = []
                let map3_legend = []
                for(let i in result) {
                    map3_xAxis.push(i)
                    for(let j in result[i]) {
                        if(map3_legend.indexOf(j)<0) {
                            map3_legend.push(j)
                        }
                        if(!map3_data[j]) {
                            map3_data[j] = []
                        }
                        map3_data[j].push({
                            'key': i,
                            'value': result[i][j]
                        })
                    }
                }
                for(let m in map3_data) {
                    map3_data[m].sort(function(a,b) {
                        return a.key-b.key
                    })
                    let temp = {
                        name: m,
                        type: 'line',
                        data: map3_data[m]
                    }
                    map3.push(temp)
                }
                map3_xAxis.sort(function(a,b) {
                    return a-b
                })
                
                let map3_list = {
                    'xAxis':map3_xAxis,
                    'legend': map3_legend,
                    'list': map3
                }
                this.lineChart(title, map3_list, chart)
        },
        getMap1(result,chart,title) {
            let map3 = []
            let map3_xAxis = []
            let map3_legend = []
            let map3_data = []
            for(let i in result) {
                map3_xAxis.push(i)
                let temp = {
                    'key': i,
                    'value': result[i]
                }
                map3_data.push(temp)
            }
            map3_xAxis.sort(function(a,b) {
                return a-b
            })
            map3_data.sort(function(a,b) {
                return a.key - b.key
            })
            map3 = [
                {
                    name: title,
                    type: 'line',
                    data: map3_data
                }
            ] 
            let map3_list = {
                'xAxis':map3_xAxis,
                'legend': map3_legend,
                'list': map3
            }
            this.lineChart(title, map3_list, chart)
        },
        getMap2(result,chart,title) {
            let xAxis = []
            if(result.length>0) {
                result.forEach((item)=>{
                    xAxis.push(item.key)
                })
            }
            xAxis.sort(function(a,b) {
                return a - b
            })
            result.sort(function(a,b) {
                return a.key - b.key
            })
            let list = [
                {
                    type: 'bar',
                    data: result
                }
            ]
            let data = {
                'xAxis': xAxis,
                'list': list
            }
            this.barChart(title,data,chart)
        },
        getWorldMap(result,chart,title) {
            let map4 = []
            for(let i in result) {
                let j = i.split('_')[0]
                if(i!='WO_WIPO') {
                    let obj = {
                        name: this.getName(j),
                        selected: true,
                        value: result[i],
                        itemStyle: {
                            normal: {
                                color: 'red'
                            },
                            emphasis: {
                                areaColor: 'blue'
                            }
                            
                        }
                    }
                    map4.push(obj)
                }
            }
            this.worldMapChart(title, map4, chart)
        },
        getName(val) {
            let name = ''
            wordNameList.forEach((item)=>{
                if(item.code == val) {
                    name = item.name
                }
            })
            return name
        },
        getScatter(result,chart,title) {
            let map7 = []
            let xData = []
            let yData =  []
            for(let i in result) {
                if(xData.indexOf(i)<0) {
                    xData.push(i)
                }
                for(let j in result[i]) {
                    if(yData.indexOf(j)<0) {
                        yData.push(j)
                    }
                    let temp = {
                        xName: i,
                        yName: j,
                        num: result[i][j]
                    }
                    map7.push(temp)
                }
            }
            xData.sort(function(a,b) {
                return a - b
            })
            yData.sort(function(a,b) {
                return a - b
            })
            map7.sort(function(a,b) {
                return a.yName - b.yName
            })
            map7.sort(function(a,b) {
                return a.xName - b.xName
            })
            yData.unshift("")
            let res = {
                'xData': xData,
                'yData': yData,
                'list': map7
            }
            this.scatterChart(title,res,chart)

        }
    }
}
</script>